// extracted by mini-css-extract-plugin
export default {"item":"DraggableItem_item__NNADy","itemDragIndicator":"DraggableItem_itemDragIndicator__rlHZn"};